var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 14H4V8C4 5.334 6 4 7.999 4H8.001C10 4 12 5.334 12 8V14ZM9 17C9 17.552 8.552 18 8 18C7.448 18 7 17.552 7 17V16H9V17ZM15 14H14V8C14 4.447 11.632 2.475 9 2.079V0H7V2.079C4.368 2.475 2 4.447 2 8V14H1C0.448 14 0 14.448 0 15C0 15.552 0.448 16 1 16H5V17C5 18.657 6.343 20 8 20C9.657 20 11 18.657 11 17V16H15C15.552 16 16 15.552 16 15C16 14.448 15.552 14 15 14Z",
    fill: "#3B414D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationSettings);
export default __webpack_public_path__ + "static/media/notification-settings.8c2310dd4a714273bc40b3f957093491.svg";
export { ForwardRef as ReactComponent };